import { globalSlice } from "@/redux/global/slice";

const actions = globalSlice.actions;

export const { setTopBar, setIsLoading, setApiClient } = actions;
